import type { QueryClient } from '@tanstack/react-query';
import type { RealtimeMessage } from './types';

/**
 * Maps push events to TanStack Query invalidations — client refetches via existing REST APIs.
 */
export function invalidateOnEvent(qc: QueryClient, message: RealtimeMessage): void {
  switch (message.type) {
    case 'NOTIFICATION_CREATED':
    case 'NOTIFICATION_READ':
      void qc.invalidateQueries({ queryKey: ['notifications'] });
      break;
    case 'APPROVAL_PENDING':
    case 'APPROVAL_RESOLVED':
      void qc.invalidateQueries({ queryKey: ['work-queue'] });
      void qc.invalidateQueries({ queryKey: ['notifications'] });
      void qc.invalidateQueries({ queryKey: ['approvals'] });
      break;
    case 'ATTENDANCE_RECORDED':
    case 'ATTENDANCE_APPROVED':
      void qc.invalidateQueries({ queryKey: ['hr'] });
      break;
    case 'INVOICE_COMPLETED':
    case 'SHIFT_OPENED':
    case 'SHIFT_CLOSED':
      void qc.invalidateQueries({ queryKey: ['dashboard'] });
      void qc.invalidateQueries({ queryKey: ['pos'] });
      break;
    case 'INVENTORY_CHANGED':
      void qc.invalidateQueries({ queryKey: ['inventory'] });
      void qc.invalidateQueries({ queryKey: ['dashboard'] });
      break;
    case 'DASHBOARD_STALE':
      void qc.invalidateQueries({ queryKey: ['dashboard'] });
      break;
    case 'POS_DISPLAY_UPDATED':
    case 'DESK_TICKET_UPDATED':
    case 'SOCIAL_MESSAGE_RECEIVED':
      // Handled by page-level subscribers — no global invalidation
      break;
    default:
      break;
  }
}
